import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
// import Header from './header';
// import Nav from './nav';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 12;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
  paddingLeft: 0,
  paddingRight: 0,
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingLeft: 0,
  paddingRight: 0,
  backgroundColor: '#f0f8ff',
  overflowY: 'hidden',
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  // const [open, setOpen] = useState(false);

  return (
    <StyledRoot
    sx={{
      ".MuiContainer-maxWidthXl": {
        paddingLeft: 2,
        paddingRight: 2
      }
    }}>
      {/* <Header onOpenNav={() => setOpen(true)} /> */}
      {/* <Nav openNav={open} onCloseNav={() => setOpen(false)} /> */}

      <Main>
        <Outlet />
      </Main>
    </StyledRoot>
  );
}
